<script setup lang="ts">
import SimpleLink from '../content/shared/SimpleLink.vue'
import { Link } from '~/lib/services/content/content.shared.dtos'

const props = defineProps<{ title?: string | null; links?: Link[] }>()
const layoutStore = useLayoutStore()
const showContent = ref(false)
const handleContent = () => {
  showContent.value = !showContent.value
}
const closeSideBar = () => {
  layoutStore.closeMenuSideBar()
}
</script>

<template>
  <div class="flex cursor-pointer flex-col content-center">
    <div
      v-if="props.title"
      class="cursor pointer mb-4 mt-8 flex items-center justify-between pr-4"
      @click="handleContent"
    >
      <p class="text-sm font-bold">
        {{ props.title }}
      </p>

      <DropDownArrowIcon :is-content-visible="showContent" />
    </div>

    <div v-if="showContent || !props.title" class="transition-all duration-1000">
      <template v-for="link of props.links" :key="String(link.title)">
        <SimpleLink :link="link" class="block" @click="closeSideBar">
          <div class="flex h-14 w-full items-center gap-4 transition-all duration-300">
            <img
              v-if="link.icon"
              class="h-auto w-6"
              :src="link.icon.url"
              :alt="link.icon.alternativeText || undefined"
            />
            <img v-else src="/images/icons/mcDonaldsLogo.svg" alt="McDonald's" />

            <p class="sidebar-link-title text-sm">{{ link.title }}</p>
          </div>
        </SimpleLink>
      </template>
    </div>
  </div>
</template>

<style scoped>
.router-link-active .sidebar-link-title {
  @apply w-fit border-b-2 border-b-mcd-main py-1;
}
</style>
